import { render, staticRenderFns } from "./AgentProfile.vue?vue&type=template&id=65350966&scoped=true&"
import script from "./AgentProfile.vue?vue&type=script&lang=ts&"
export * from "./AgentProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AgentProfile.vue?vue&type=style&index=0&id=65350966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65350966",
  null
  
)

export default component.exports